import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Icon from './Icon';
import { getAccessToken, isSecretaryContextUser } from '../authStorage';
import { fetchDecisionTypeById } from '../decisionTypesApi';
import { useLanguage } from '../i18n/language';
import { useT } from '../i18n/translations';
import './BranchesPage.css';
import './BoardPage.css';

function DecisionTypeDetailPage() {
  const { direction } = useLanguage();
  const t = useT();
  const navigate = useNavigate();
  const { id: idParam } = useParams();
  const typeId = Number(idParam);
  const invalidId = !Number.isFinite(typeId) || typeId < 1;
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(!invalidId);
  const [loadError, setLoadError] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    if (!getAccessToken()) { navigate('/login', { replace: true }); return; }
    if (!isSecretaryContextUser()) { setAccessDenied(true); setLoading(false); return; }
    if (invalidId) { setLoadError(t('decisionTypes.invalidId')); setLoading(false); return; }
    let cancelled = false;
    (async () => {
      setLoading(true); setLoadError('');
      try {
        const row = await fetchDecisionTypeById(typeId);
        if (!cancelled) setItem(row);
      } catch (e) {
        if (!cancelled) setLoadError(e instanceof Error ? e.message : t('common.errorLoad'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [navigate, typeId, invalidId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (accessDenied) return <p style={{ padding: 24, color: '#78909c', fontFamily: 'Cairo, sans-serif' }}>{t('common.noPerm')}</p>;

  return (
    <div className="page" dir={direction}>
      <div className="list-page-card list-page-card--unified">
        <header className="list-page-card__header">
          <div className="list-page-card__titles">
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
              <button type="button" className="btn btn--ghost" onClick={() => navigate('/app/decision-types')}>
                <Icon name="chevron-right" size={14} /> {t('common.back')}
              </button>
              <span className="list-page-card__title"><Icon name="decisions" size={18} color="#00334a" style={{ verticalAlign: 'middle', marginLeft: 6 }} />{t('decisionTypes.pageTitle')}</span>
            </div>
            <span className="list-page-card__sub">{item?.name || (loading ? t('decisionTypes.loadingDetails') : '')}</span>
          </div>
          {item && (
            <div className="list-page-card__actions">
              <button type="button" className="btn btn--primary" onClick={() => navigate(`/app/decision-types/${item.id}/edit`)}><Icon name="edit" size={14} color="#fff" /> {t('decisionTypes.edit')}</button>
            </div>
          )}
        </header>
        {loadError && <div className="list-page-card__banner list-page-card__banner--error">{loadError}</div>}
        {loading && <div className="list-page-card__loading">{t('common.loading')}</div>}
      {!loading && item && (
        <div className="table-card" style={{ padding: '20px 22px' }}>
          <div className="mform">
            <div className="mform__row mform__row--4">
              <div className="mform__field"><label className="mform__label">{t('decisionTypes.lblName')}</label><div className="mform__input-wrap"><Icon name="decisions" size={14} color="#02c3a6" className="mform__input-icon" /><input className="mform__input mform__input--with-icon" value={item.name || ''} disabled /></div></div>
              <div className="mform__field mform__field--span3"><label className="mform__label">{t('decisionTypes.lblBranch')}</label><div className="mform__input-wrap"><Icon name="branch" size={14} color="#1b8eff" className="mform__input-icon" /><input className="mform__input mform__input--with-icon" value={item.branch || ''} disabled /></div></div>
            </div>
            <div className="mform__row mform__row--4">
              <div className="mform__field mform__field--span3"><label className="mform__label">{t('decisionTypes.lblDescription')}</label><div className="mform__input-wrap"><Icon name="report" size={14} color="#8b5cf6" className="mform__input-icon" /><input className="mform__input mform__input--with-icon" value={item.description || ''} disabled /></div></div>
              <div className="mform__field"><label className="mform__label">{t('decisionTypes.lblStatus')}</label><div className="mform__input-wrap"><Icon name="settings" size={14} color="#14b8a6" className="mform__input-icon" /><input className="mform__input mform__input--with-icon" value={item.status === 'active' ? t('decisionTypes.active') : t('decisionTypes.inactive')} disabled /></div></div>
            </div>
            <div className="mform__row mform__row--4">
              <div className="mform__field"><label className="mform__label">{t('decisionTypes.lblCreatedAt')}</label><div className="mform__input-wrap"><Icon name="calendar" size={14} color="#ff8c42" className="mform__input-icon" /><input className="mform__input mform__input--with-icon" value={item.createdAt || ''} dir="ltr" disabled /></div></div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default DecisionTypeDetailPage;
